<h2 mat-dialog-title class="login-title">
  {{ mode === 'signin' ? 'Sign in' : mode === 'signup' ? 'Create account' : 'Reset password' }}
</h2>

<mat-dialog-content>
  <form *ngIf="mode !== 'forgot'" [formGroup]="loginForm" (ngSubmit)="submit()" class="login-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Company name</mat-label>
      <input matInput formControlName="companyName" autocomplete="organization" cdkFocusInitial />
      <mat-error *ngIf="loginForm.get('companyName')?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ mode === 'signin' ? 'Email or username' : 'Email' }}</mat-label>
      <input matInput formControlName="identifier"
             [autocomplete]="mode === 'signin' ? 'username' : 'email'"
             [type]="mode === 'signup' ? 'email' : 'text'" />
      <mat-error *ngIf="loginForm.get('identifier')?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password"
             [type]="hidePassword ? 'password' : 'text'"
             [autocomplete]="mode === 'signin' ? 'current-password' : 'new-password'" />
      <button mat-icon-button matSuffix type="button"
              (click)="hidePassword = !hidePassword"
              [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'">
        <br-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</br-icon>
      </button>
      <mat-error *ngIf="loginForm.get('password')?.hasError('required')">Password is required</mat-error>
      <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')">At least 8 characters</mat-error>
    </mat-form-field>

    <p *ngIf="mode === 'signin'" class="forgot-link">
      <button type="button" class="br-btn br-btn--link br-btn--sm"
              (click)="switchMode('forgot')" [disabled]="submitting">
        Forgot password?
      </button>
    </p>

    <p *ngIf="serverError" class="br-alert br-alert--danger server-error" role="alert">{{ serverError }}</p>

    <button type="submit"
            class="br-btn br-btn--primary br-w-full login-action"
            [disabled]="loginForm.invalid || submitting">
      {{ submitting
        ? (mode === 'signin' ? 'Signing in…' : 'Creating account…')
        : (mode === 'signin' ? 'Sign in' : 'Create account') }}
    </button>

    <button type="button"
            class="br-btn br-btn--outline-secondary br-w-full login-action"
            mat-dialog-close
            [disabled]="submitting">
      Cancel
    </button>
  </form>

  <form *ngIf="mode === 'forgot'" [formGroup]="forgotForm" (ngSubmit)="submitForgot()" class="login-form">
    <ng-container *ngIf="!forgotEmailSent; else sentMessage">
      <p class="forgot-intro">Enter your company name and email and we'll send you a link to reset your password.</p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Company name</mat-label>
        <input matInput formControlName="companyName" autocomplete="organization" cdkFocusInitial />
        <mat-error *ngIf="forgotForm.get('companyName')?.hasError('required')">Required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" autocomplete="email" />
        <mat-error *ngIf="forgotForm.get('email')?.hasError('required')">Required</mat-error>
        <mat-error *ngIf="forgotForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
      </mat-form-field>

      <p *ngIf="serverError" class="br-alert br-alert--danger server-error" role="alert">{{ serverError }}</p>

      <button type="submit"
              class="br-btn br-btn--primary br-w-full login-action"
              [disabled]="forgotForm.invalid || submitting">
        {{ submitting ? 'Sending…' : 'Send reset link' }}
      </button>
    </ng-container>

    <ng-template #sentMessage>
      <p class="forgot-intro">If an account exists for that company and email, a reset link has been sent.</p>
    </ng-template>

    <button type="button"
            class="br-btn br-btn--outline-secondary br-w-full login-action"
            (click)="switchMode('signin')"
            [disabled]="submitting">
      Back to sign in
    </button>
  </form>

  <!-- Temporarily disabled while self-service tenant signup is closed.
  <p class="mode-switch" *ngIf="mode !== 'forgot'">
    <ng-container *ngIf="mode === 'signin'; else toSignin">
      Don't have an account?
      <button type="button" class="br-btn br-btn--link br-btn--sm"
              (click)="switchMode('signup')" [disabled]="submitting">
        Create account
      </button>
    </ng-container>
    <ng-template #toSignin>
      Already have an account?
      <button type="button" class="br-btn br-btn--link br-btn--sm"
              (click)="switchMode('signin')" [disabled]="submitting">
        Sign in
      </button>
    </ng-template>
  </p>
  -->
</mat-dialog-content>
